<template>
  <node-view-wrapper :class="IsCollapsed ? 'draggable-item collapsed' : 'draggable-item'"
                     ref="node"
                     v-bind="ExtractAttributes(node.attrs)">
    
    <div class="tools">
      <span class="drag-handle tool"
            contenteditable="false"
            draggable="true"
            data-drag-handle>&nbsp;</span>

    </div>
    <div  class="inner">
      <node-view-content ref="content" class="content" />
    </div>
    <div class="tools-right">
      <span class="expander tool arrows" @click="ChangeNodeExpandedState" title="Expand/Collapse step">
        <img src="/images/icons/tiptap/arrow-down-circle-line.svg" v-if="IsCollapsed && !IsCodeStep" />
        <img src="/images/icons/tiptap/arrow-up-circle-line.svg" v-if="!IsCollapsed && !IsCodeStep" />
      </span>
      
      <!-- Dropdown Menu -->
      <vs-dropdown trigger="click">
        <span class="tool dropdown-trigger" title="Step actions">
          <i class="fas fa-ellipsis-v"></i>
        </span>
        
        <vs-dropdown-menu>
          <!-- Delete Option -->
          <vs-dropdown-item @click="PromptForDelete">
            <i class="fas fa-trash mr-2 text-red-600"></i>
            Delete
          </vs-dropdown-item>
          
          <!-- Code View Option (for code steps) -->
          <vs-dropdown-item v-if="IsCodeStep" @click="ExtractStepCode">
            <i class="fas fa-code mr-2 text-blue-600"></i>
            Code View
          </vs-dropdown-item>
          
          <!-- Form Properties Option (for form steps) -->
          <vs-dropdown-item v-if="IsFormCaptureStep" @click="ExtractFormProperties">
            <i class="fas fa-clipboard-list mr-2 text-orange-600"></i>
            Form Properties
          </vs-dropdown-item>
          
          <!-- Assign Properties Option (for SOP steps) -->
          <vs-dropdown-item v-if="IsAssignSOPStep" @click="ExtractAssignSOPProperties">
            <i class="fas fa-users mr-2 text-purple-600"></i>
            Assign Properties
          </vs-dropdown-item>
          
          <!-- General Properties Option -->
          <vs-dropdown-item @click="ExtractMetadata">
            <i class="fas fa-cog mr-2 text-gray-600"></i>
            Properties
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </node-view-wrapper>
</template>

<script>
  import { NodeViewContent, nodeViewProps, NodeViewWrapper } from '@tiptap/vue-2'
  import { EventBus } from '@/eventBus/eventBus.js';
  import MonacoEditor from '@/views/components/extra-components/editors/MonacoEditor.vue';

  export default {
    props: nodeViewProps,
    mounted() {
      var codeIdCheck = (this.node.attrs["data-attributes"]["data-subtype"])
      if (this.node.attrs["data-attributes"]["data-subtype"] == "code") {
        this.IsCodeStep = true;
      }
      if (this.node.attrs["data-attributes"]["data-subtype"] == "form-capture") {
        this.IsFormCaptureStep = true;
      }
      if (this.node.attrs["data-attributes"]["data-subtype"] == "assign-sop") {
        this.IsAssignSOPStep = true;
      }
      var parentId = (this.node.attrs["data-attributes"]["data-step-id"])
      if (parentId == null) {
        parentId = this.node.attrs["data-attributes"]["data-temp-step-id"];
      }
     

        EventBus.$on(`close_menu_${parentId}`, () => {
          this.IsCollapsed = true;
          this.$nextTick(() => {
            var el = this.$refs.content.$el.children.item(0)
            //Moves the cursor
            let range = document.createRange();
            let sel = window.getSelection();
            range.selectNodeContents(el);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
          });
        });

        EventBus.$on(`open_menu_enter_${parentId}`, () => {
          this.IsCollapsed = false;
          this.$nextTick(() => {
            var el = this.$refs.content.$el.children.item(1)
            //Moves the cursor
            let range = document.createRange();
            let sel = window.getSelection();
            range.selectNodeContents(el);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          });
        });

        // Add paste event listener to ensure paste events propagate to the main editor
        this.$refs.content.$el.addEventListener('paste', (e) => {
          console.log('Paste event in NodeViewContent:', e);
          // Let the event bubble up to the main editor
          // Don't prevent default here, let the main editor handle it
        });
    },
    beforeDestroy() {
      // Clean up event listeners
      document.removeEventListener('click', this.handleClickOutside);
    },
    data() {
      return {
        IsCollapsed: true,
        IsCodeStep:false,
        IsFormCaptureStep: false,
        IsAssignSOPStep: false,
      }
    },
    methods: {

      ChangeNodeExpandedState() {
        this.IsCollapsed = !this.IsCollapsed
      },
      PromptForDelete() {
        if (confirm("Are you sure?")) {
          this.deleteNode();
        }
      },
      ExtractMetadata() {
        var instance = this
        //var metadatawrapper = this.$refs.node.$el.querySelector('.content p:nth-of-type(3)');
        //var content = this.$refs.node.$el.querySelector('.content');
        //if (metadatawrapper == null) {
        //  metadatawrapper = document.createElement("p");
        //  content.appendChild(metadatawrapper);

        //}
        //var metadata = metadatawrapper.innerHTML;
        //var stepId = this.$refs.node.$attrs["data-step-id"]
        var element = instance.$refs.node.$el
        EventBus.$emit('metadataProvided', element);
        
      },
      ExtractStepCode() {
        var instance = this
        var element = instance.$refs.node.$el
        EventBus.$emit('codeStepCalled', element);

      },
      ExtractFormProperties() {
        var instance = this
        var element = instance.$refs.node.$el
        EventBus.$emit('formCapturePropertiesCalled', element);
      },
      ExtractAssignSOPProperties() {
        var instance = this
        var element = instance.$refs.node.$el
        EventBus.$emit('assignSOPPropertiesCalled', element);
      },
      ExtractAttributes(attrs) {
        const { 'data-attributes': dataAttributes, ...rest } = attrs;
        return {
          ...rest,
          ...dataAttributes, // Flatten the data-attributes object into the DOM
        };
      }
    },
    components: {
      NodeViewWrapper,
      NodeViewContent,
      MonacoEditor
    },
  }
</script>

<style>

  .inner {
    margin-left: 0px;
    /*border-radius: 50px;*/
    display: flex;
    /*padding: 0.4rem;
    margin: 0.4rem 0;
    border-radius: 0.5rem;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1);*/
    overflow: visible; /* Ensure buttons are not cut off */
  }

  p.drop-target:hover {
    background-color: #d0e7ff;
  }

  [data-node-view-content] {
    border: 1px solid silver;
    border-radius:5px;
  }

  [data-node-view-content] p:first-child{
    border-radius:10px;
    padding-left:10px;
    padding-top:4px;
  }

    [data-node-view-content] p:nth-child(3) {
      display: none !important;
    }

  /* Code block styling within draggable items */
  [data-node-view-content] pre {
    background: #0D0D0D;
    color: #FFF;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    margin: 0.5rem 0;
    overflow-x: auto;
  }

  [data-node-view-content] pre code {
    color: inherit;
    padding: 0;
    background: none;
    font-size: 0.8rem;
  }

  /* Inline code styling */
  [data-node-view-content] code {
    background-color: rgba(97, 97, 97, 0.1);
    color: #616161;
    padding: 0.2rem 0.4rem;
    border-radius: 0.25rem;
    font-family: 'JetBrainsMono', monospace;
    font-size: 0.9em;
  }

  .delete-button {
    width: 24px !important;
    height: 24px !important;
    min-height: 24px;
    min-width: 24px;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  /* Ensure the node view wrapper doesn't clip the buttons */
  .draggable-item {
    padding-left: 20px;
    position: relative;
    margin: 20px 0; /* Add margin to reserve space for buttons */
    overflow: visible; /* Ensure buttons are not cut off */
  }

  /* Additional wrapper styling to prevent clipping */
  .draggable-item > * {
    overflow: visible;
  }

  /* Ensure collapsed steps have enough space for buttons */
  .draggable-item.collapsed {
    /*margin: 15px 0;*/ /* Slightly less margin for collapsed steps */
    /*max-height: 4rem !important;
    min-height: 4rem;
    overflow: visible;*/ /* Allow buttons to show outside collapsed step */
  }

      .draggable-item.collapsed [data-node-view-content] p:first-child {
        display: block !important;
        margin-top: 0px !important;
      }

    .draggable-item [data-node-view-content] p:nth-child(2) {
      display: block;
      min-height: 40px;
      border: 1px dashed silver;
      padding: 10px;
      /*margin: 10px;*/
      background: #efefef;
    }

      .draggable-item.collapsed [data-node-view-content] p:nth-child(2){
          display:none;
      }

      /* Hide code blocks when collapsed */
      .draggable-item.collapsed [data-node-view-content] pre {
        display: none;
      }

      .draggable-item:hover .tools {
        display: block !important;
        position: absolute;
        left: 0px;
        width: 100px;
        margin-top: 10px;
        top: 0px;
      }

    .draggable-item:hover .tools-right {
      display: block !important;
      position: absolute;
      right: 0px;
      /*width: 100px;*/
      margin-right:10px;
      margin-top: 10px;
      top:0px;
      background:#efefef;
      padding:3px;
      border-radius:5px;
    }

  .tools {
    display: none;
  }

  [data-subtype] {
    /*border-style: solid;
    border-radius: 0.5rem;*/
  }

  [data-subtype='informational'] {
    border-color: rgba(var(--vs-info),1) !important;
  }

  [data-subtype='success'] {
    border-color: rgba(var(--vs-success),1) !important;
  }

  [data-subtype='error'] {
    border-color: rgba(var(--vs-error),1) !important;
  }

  [data-subtype='warning'] {
    border-color: rgba(var(--vs-warning),1) !important;
  }

  [data-subtype='informational'] p:first-of-type {
    background: rgba(var(--vs-info),1) !important;
    color: white;
  }

  [data-subtype='success'] p:first-of-type {
    background: rgba(var(--vs-success),1) !important;
    color: white;
  }

  [data-subtype='error'] p:first-of-type {
    background: rgba(var(--vs-error),1) !important;
    color: white;
  }

  [data-subtype='warning'] p:first-of-type {
    background: rgba(var(--vs-warning),1) !important;
    color: white;
  }

  [data-subtype ='informational'] div.content {
    border-color: rgba(var(--vs-info),1) !important;
    background: rgba(var(--vs-info),1) !important;
  }

    [data-subtype ='informational'] div.content p:first-child,
    [data-subtype ='warning'] div.content p:first-child,
    [data-subtype ='error'] div.content p:first-child,
    [data-subtype ='success'] div.content p:first-child {
      color: white
    }

    [data-subtype ='success'] div.content {
      border-color: rgba(var(--vs-success),1) !important;
      background: rgba(var(--vs-success),1) !important;
    }

  [data-subtype ='error'] div.content {
    border-color: rgba(var(--vs-error),1) !important;
    background: rgba(var(--vs-error),1) !important;
  }

  [data-subtype ='warning'] div.content {
    border-color: rgba(var(--vs-warning),1) !important;
    background: rgba(var(--vs-warning),1) !important;
  }

  .tools-right {
    display: none;
  }

  .tools .tool, .tools-right .tool {
    float: left;
    display: inline-block;
    margin-top:5px;
  }

    .tools .tool img, .tools-right .tool img {
      max-width: 20px;
      max-height: 20px;
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

  .dropdown-trigger {
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 3px;
    transition: background-color 0.2s;
  }

  .dropdown-trigger:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .dropdown-trigger i {
    font-size: 14px;
    color: #666;
  }

  .drag-handle {
    /*flex: 0 0 auto;*/
    /*position: relative;*/
    min-width: 1rem;
    /*height: 2rem;*/
    /*top: 0.5rem;*/
    margin-right: 0.5rem;
    cursor: grab;
    background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16"><path fill="silver" fill-opacity="1" d="M4 14c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 6C.9 6 0 6.9 0 8s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" /></svg>');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    /*margin-top: 12px;*/
  }

  .content {
    flex: 1 1 auto;
    max-width: calc(100% - 40px);
    width: calc(100% - 40px);
    min-width: calc(100% - 40px);
  }

  @media (max-width: 768px) {
    .draggable-item.collapsed {
      max-height: none !important;
      min-height: auto;
      overflow: visible;
    }

      .draggable-item.collapsed [data-node-view-content] p:nth-child(2) {
        display: block;
      }

      .draggable-item.collapsed [data-node-view-content] pre {
        display: block;
      }

    .arrows {
        display:none !important;
    }

    .draggable-item {
      padding-left: 0px;
      margin: 10px 0; /* Reduce margin on mobile */
    }

    .content {
      max-width:none
    }
  }
</style>
